export const searchItems = [
  // 用户名称
  {
    label: '用户名称',
    type: 'input',
    decorator: ['userName'],
    placeholder: '请输入用户名称'
  },
  // 证件号
  {
    label: '证件号',
    type: 'input',
    decorator: ['idNumber'],
    placeholder: '请输入证件号'
  },
  // 手机号
  {
    label: '手机号',
    type: 'input',
    decorator: ['phone'],
    placeholder: '请输入手机号'
  },
  // 手机号
  {
    label: '员工号',
    type: 'input',
    decorator: ['workNumber'],
    placeholder: '请输入员工号'
  }
]
